import React from 'react'
import "../banner/Banner.css"
import { Col, Container, Row } from 'react-bootstrap'
const Banner = () => {
  return (
    <>
     <section id="banners">
      <Container>
        <Row style={{rowGap: "20px"}}>
          <Col lg={6}>
            <div class="banner_inner">
              <div class="banner_inner_main">
                <h1>We are Extreamly
                    <br/>   <span class="sp">Organic</span> </h1>
                <p>Donec sollicitudin molestie malesuada. Lorem ipsum dolor sit amet,consectetur adipiscing elit.</p>
                <a href="#"><button class="shop_now">shop now</button></a>
              </div>

            </div>
          </Col>
          <Col lg={6}>
            <Row style={{rowGap: "20px"}}>
              <Col lg={12}>
                <div class="banner_inner_next">
                  <div class="banner_inner_next_inner">
                    <h4>Buy Fruits Online</h4>
                    <a href="#"><button class="shop_now">shop now</button></a>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className='banners-3'>
                 <img src="imeges/banner 4.jpg" class="w-100" alt=""/> 
                </div>
              </Col>
              <Col lg={6}>
              <div className='banners-3'>
                <img src="imeges/banner 4.jpg" class="w-100" alt=""/>
              </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
    </>
  )
}

export default Banner